/**
 * Theme Manager - handles system theme detection and switching
 */

let mediaQuery = null;
let currentListener = null;

/**
 * Get system's preferred color scheme
 * @returns {boolean} true if system prefers dark mode
 */
export function getSystemDarkMode() {
  if (typeof window === "undefined") return false;
  return window.matchMedia("(prefers-color-scheme: dark)").matches;
}

/**
 * Apply theme based on preferences
 * @param {Object} vuetify - Vuetify instance
 * @param {Object} preferences - User preferences { theme: 'use_system_theme' | 'light' | 'dark' }
 */
export function applyTheme(vuetify, preferences) {
  if (preferences.theme === "use_system_theme") {
    vuetify.theme.dark = getSystemDarkMode();
  } else {
    vuetify.theme.dark = preferences.theme === "dark";
  }
}

/**
 * Start listening for system theme changes
 * @param {Object} vuetify - Vuetify instance
 * @param {Function} getPreferences - Function that returns current preferences
 */
export function startSystemThemeListener(vuetify, getPreferences) {
  stopSystemThemeListener();

  if (typeof window === "undefined") return;

  mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");

  currentListener = (e) => {
    const preferences = getPreferences();
    if (preferences && preferences.theme === "use_system_theme") {
      vuetify.theme.dark = e.matches;
    }
  };

  mediaQuery.addEventListener("change", currentListener);
}

/**
 * Stop listening for system theme changes
 */
export function stopSystemThemeListener() {
  if (mediaQuery && currentListener) {
    mediaQuery.removeEventListener("change", currentListener);
    currentListener = null;
    mediaQuery = null;
  }
}
